import React from 'react';
import DefaultNavigationButton from 'components/NavigationButton';
import type { NavigationButtonProps } from 'components/NavigationButton/NavigationButton';
import type { ScrollSnapAutoplay } from 'scroll-snap-slider';
import useScrollSnapSliderContext from '../hooks/useScrollSnapSliderContext';

type INavigationButton = NavigationButtonProps & {
    slideAmount?: number;
};

export default function NavigationButton({ direction, slideAmount = 1, ...restProps }: INavigationButton) {
    const slider = useScrollSnapSliderContext();

    return (
        <DefaultNavigationButton
            direction={direction}
            onClick={() => {
                if (slider) {
                    (slider.plugins.get('ScrollSnapAutoplay') as ScrollSnapAutoplay)?.disableTemporarily();
                    const targetSlide = direction === 'prev' ? slider.slide - slideAmount : slider.slide + slideAmount;
                    slider.slideTo(targetSlide);
                }
            }}
            {...restProps}
        />
    );
}
